import PropTypes from 'prop-types';

export const interventionType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  categories: PropTypes.arrayOf(PropTypes.number).isRequired,
  label: PropTypes.string.isRequired
});